export default Object.freeze({
    NONE: 0,            // default no state
    RENDERING: 1,       // component is rendering (react.lazy)
    IDLE: 2,            // component is idle (animation is ready to be loaded)
    LOADING: 3,         // animation is being loaded
    READY: 4,           // animation is ready
    PAUSED: 5,          // animation is paused
    PLAYING: 6,         // animation is playing
    ERROR: 7,           // error occured while loading animation
});
